var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}

import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { logOut } from '../actions/authentication/logOut';
import { getAuthToken } from '../helpers';

var PrivateRoute = function PrivateRoute(_ref) {
  var Component = _ref.component,
      location = _ref.location,
      logOut = _ref.logOut,
      rest = _objectWithoutProperties(_ref, ['component', 'location', 'logOut']);

  var authToken = getAuthToken();

  if (!authToken || authToken === '0') {
    logOut();
  }

  return React.createElement(Route, _extends({}, rest, {
    render: function render(props) {
      return authToken && authToken !== '0' ? React.createElement(Component, props) : React.createElement(Redirect, {
        to: {
          pathname: '/login',
          state: {
            from: location
          }
        }
      });
    }
  }));
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    logOut: logOut
  }, dispatch);
};

export default connect(null, mapDispatchToProps)(PrivateRoute);